import 'core-js/es/array';

export default class Filters {
    constructor() {

        this.init();

    }

    init() {
        // todo: update to specify only filters
        var allCheckboxes = document.querySelectorAll('input[type=checkbox]');
        var allItems = Array.from(document.querySelectorAll('.c-timeline-rns__month'));
        var checked = {};

        getChecked('filtergroup0');
        getChecked('filtergroup1');
        getChecked('filtergroup2');
        getChecked('filtergroup3');
        getChecked('filtergroup4');
        getChecked('filtergroup5');
        getChecked('filtergroup6');
        getChecked('filtergroup7');
        getChecked('filtergroup8');
        getChecked('filtergroup9');


        Array.prototype.forEach.call(allCheckboxes, function (el) {
            el.addEventListener('change', toggleCheckbox);
        });

        function toggleCheckbox(e) {
            getChecked(e.target.name);
            setVisibility();
        }

        function getChecked(name) {
            checked[name] = Array.from(document.querySelectorAll('input[name=' + name + ']:checked')).map(function (el) {
                return el.value;
            });
        }

        function setVisibility() {
            allItems.map(function (el) {
                let filterArray0 = [Array.from(el.classList), checked.filtergroup0];
                let filterArray0Arrays = filterArray0.reduce((a, b) => a.filter(c => b.includes(c)));
                var filtergroup0Result = checked.filtergroup0.length ? filterArray0Arrays.length : true;
                let filterArray1 = [Array.from(el.classList), checked.filtergroup1];
                let filterArray1Arrays = filterArray1.reduce((a, b) => a.filter(c => b.includes(c)));
                var filtergroup1Result = checked.filtergroup1.length ? filterArray1Arrays.length : true;
                let filterArray2 = [Array.from(el.classList), checked.filtergroup2];
                let filterArray2Arrays = filterArray2.reduce((a, b) => a.filter(c => b.includes(c)));
                var filtergroup2Result = checked.filtergroup2.length ? filterArray2Arrays.length : true;
                let filterArray3 = [Array.from(el.classList), checked.filtergroup3];
                let filterArray3Arrays = filterArray3.reduce((a, b) => a.filter(c => b.includes(c)));
                var filtergroup3Result = checked.filtergroup3.length ? filterArray3Arrays.length : true;
                let filterArray4 = [Array.from(el.classList), checked.filtergroup4];
                let filterArray4Arrays = filterArray4.reduce((a, b) => a.filter(c => b.includes(c)));
                var filtergroup4Result = checked.filtergroup4.length ? filterArray4Arrays.length : true;
                let filterArray5 = [Array.from(el.classList), checked.filtergroup5];
                let filterArray5Arrays = filterArray5.reduce((a, b) => a.filter(c => b.includes(c)));
                var filtergroup5Result = checked.filtergroup5.length ? filterArray5Arrays.length : true;
                let filterArray6 = [Array.from(el.classList), checked.filtergroup6];
                let filterArray6Arrays = filterArray6.reduce((a, b) => a.filter(c => b.includes(c)));
                var filtergroup6Result = checked.filtergroup6.length ? filterArray6Arrays.length : true;
                let filterArray7 = [Array.from(el.classList), checked.filtergroup7];
                let filterArray7Arrays = filterArray7.reduce((a, b) => a.filter(c => b.includes(c)));
                var filtergroup7Result = checked.filtergroup7.length ? filterArray7Arrays.length : true;
                let filterArray8 = [Array.from(el.classList), checked.filtergroup8];
                let filterArray8Arrays = filterArray8.reduce((a, b) => a.filter(c => b.includes(c)));
                var filtergroup8Result = checked.filtergroup8.length ? filterArray8Arrays.length : true;
                let filterArray9 = [Array.from(el.classList), checked.filtergroup9];
                let filterArray9Arrays = filterArray9.reduce((a, b) => a.filter(c => b.includes(c)));
                var filtergroup9Result = checked.filtergroup9.length ? filterArray9Arrays.length : true;

                if (filtergroup0Result &&
                    filtergroup1Result &&
                    filtergroup2Result &&
                    filtergroup3Result &&
                    filtergroup4Result &&
                    filtergroup5Result &&
                    filtergroup6Result &&
                    filtergroup7Result &&
                    filtergroup8Result &&
                    filtergroup9Result) {
                    el.style.display = 'flex';
                } else {
                    el.style.display = 'none';
                }
            });
        }
    }




}